<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Eislauf</h3>
<p class="vers">Auf spiegelndem Teiche<br class="calibre2"/>
zieh' ich spiegelnde Gleise.<br class="calibre2"/>
Der Kauz ruft leise.<br class="calibre2"/>
Der Mond, der bleiche,<br class="calibre2"/>
liegt über dem Teiche.</p>
<p class="vers">Im raschelnden Schilfe,<br class="calibre2"/>
da weben die Mären,<br class="calibre2"/>
da lachet der Sylphe<br class="calibre2"/>
in silbernen Zähren,<br class="calibre2"/>
tief innen im Schilfe.</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page29" title="wedi/Konmax"></a> Hei, fröhliches Kreisen,<br class="calibre2"/>
dem Winde befohlen!<br class="calibre2"/>
Glückseliges Reisen,<br class="calibre2"/>
die Welt an den Sohlen,<br class="calibre2"/>
in eigenen Kreisen!</p>
<p class="vers">Vergessen, vergeben,<br class="calibre2"/>
im Mondlicht baden;<br class="calibre2"/>
hingaukeln und schweben<br class="calibre2"/>
auf nächtigen Pfaden!<br class="calibre2"/>
Sich selber nur leben!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0014.vue?77e896e4